import React from 'react'
import { connect } from 'react-redux'
import { t } from 'ttag'
import { Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import LoadingIndicator from '../../components/LoadingIndicator'
import withRecharts from '../../components/withRecharts'
import { useInitDispatch, useTitleChange } from '../../util/hooks'
import { loadSupplyDemand } from '../../actions/industry'

class SupplyDemandCluster extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      sortCol: null,
      sortAsc: true
    }
  }

  toggleSort(col) {
    if (this.state.sortCol == col) {
      this.setState({
        ...this.state,
        sortAsc: !this.state.sortAsc
      })
    } else {
      this.setState({
        ...this.state,
        sortCol: col
      })
    }
  }

  showIcon(col) {
    if (this.state.sortCol === col) {
      if (this.state.sortAsc) {
        return <i className="fal fa-sort-asc" style={{ fontSize: '.7em' }}></i>
      }

      return <i className="fal fa-sort-desc" style={{ fontSize: '.7em' }}></i>
    }

    return <i className="fal fa-sort" style={{ fontSize: '.7em' }}></i>
  }

  sortIt(inp) {
    switch (this.state.sortCol) {
      case 0:
        const sorted = inp.sort((a, b) => {
          if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return -1
          }

          if (b.name.toLowerCase() > a.name.toLowerCase()) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted : sorted.reverse()
      case 1:
        const sorted2 = inp.sort((a, b) => {
          if (a.sup - b.sup > 0) {
            return -1
          }

          if (b.sup - a.sup > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted2 : sorted2.reverse()
      case 2:
        const sorted3 = inp.sort((a, b) => {
          if (a.dmd - b.dmd > 0) {
            return -1
          }

          if (b.dmd - a.dmd > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted3 : sorted3.reverse()
      case 3:
        const sorted4 = inp.sort((a, b) => {
          if (a.v - b.v > 0) {
            return -1
          }

          if (b.v - a.v > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted4 : sorted4.reverse()
      default:
        return inp
    }

    return inp
  }

  render() {
    return (
      <table className="tbl table tbl-striped">
        <thead>
          <tr>
            <th>
              <a href="javascript:void(0)" onClick={() => this.toggleSort(0)}>
                {t`Name`} {this.showIcon(0)}
              </a>
            </th>
            <th>
              <a href="javascript:void(0)" onClick={() => this.toggleSort(1)}>
                {t`Supply`} {this.showIcon(1)}
              </a>
            </th>
            <th>
              <a href="javascript:void(0)" onClick={() => this.toggleSort(2)}>
                {t`Demand`} {this.showIcon(2)}
              </a>
            </th>
            <th>
              <a href="javascript:void(0)" onClick={() => this.toggleSort(3)}>
                {t`Value`} {this.showIcon(3)}
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          {this.sortIt(this.props.data).map((d, idx) => (
            <tr key={d.name} className={idx % 2 ? 'even' : 'odd'}>
              <td>
                <Link to={`/clusters/detail/${d.clusterId}`}>{d.name}</Link>
              </td>
              <td>{d.sup && d.sup.toLocaleString()}</td>
              <td>{d.dmd && d.dmd.toLocaleString()}</td>
              <td>{d.v && d.v.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}

class SupplyDemandJZ extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      sortCol: null,
      sortAsc: true
    }
  }

  toggleSort(col) {
    if (this.state.sortCol == col) {
      this.setState({
        ...this.state,
        sortAsc: !this.state.sortAsc
      })
    } else {
      this.setState({
        ...this.state,
        sortCol: col
      })
    }
  }

  showIcon(col) {
    if (this.state.sortCol === col) {
      if (this.state.sortAsc) {
        return <i className="fal fa-sort-asc" style={{ fontSize: '.7em' }}></i>
      }

      return <i className="fal fa-sort-desc" style={{ fontSize: '.7em' }}></i>
    }

    return <i className="fal fa-sort" style={{ fontSize: '.7em' }}></i>
  }

  sortIt(inp) {
    switch (this.state.sortCol) {
      case 0:
        const sorted = inp.sort((a, b) => {
          if (a.jobZone > b.jobZone) {
            return -1
          }

          if (b.jobZone > a.jobZone) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted : sorted.reverse()
      case 1:
        const sorted2 = inp.sort((a, b) => {
          if (a.sup - b.sup > 0) {
            return -1
          }

          if (b.sup - a.sup > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted2 : sorted2.reverse()
      case 2:
        const sorted3 = inp.sort((a, b) => {
          if (a.dmd - b.dmd > 0) {
            return -1
          }

          if (b.dmd - a.dmd > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted3 : sorted3.reverse()
      case 3:
        const sorted4 = inp.sort((a, b) => {
          if (a.v - b.v > 0) {
            return -1
          }

          if (b.v - a.v > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted4 : sorted4.reverse()
      default:
        return inp
    }

    return inp
  }

  render() {
    return (
      <table className="tbl table tbl-striped">
        <thead>
          <tr>
            <th>
              <a href="javascript:void(0)" onClick={() => this.toggleSort(0)}>
                {t`Job Zone`} {this.showIcon(0)}
              </a>
            </th>
            <th>
              <a href="javascript:void(0)" onClick={() => this.toggleSort(1)}>
                {t`Supply`} {this.showIcon(1)}
              </a>
            </th>
            <th>
              <a href="javascript:void(0)" onClick={() => this.toggleSort(2)}>
                {t`Demand`} {this.showIcon(2)}
              </a>
            </th>
            <th>
              <a href="javascript:void(0)" onClick={() => this.toggleSort(3)}>
                {t`Value`} {this.showIcon(3)}
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          {this.sortIt(this.props.data).map((d, idx) => (
            <tr key={d.jobZone} className={idx % 2 ? 'even' : 'odd'}>
              <td>{d.jobZone || t`N/A`}</td>
              <td>{d.sup && d.sup.toLocaleString()}</td>
              <td>{d.dmd && d.dmd.toLocaleString()}</td>
              <td>{d.v && d.v.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}

class OccSupplyDemandPathway extends React.PureComponent {
  constructor(props) {
    super(props)
    console.log('CID: ', props.clusterId, props.data)
    this.state = {
      sortCol: null,
      sortAsc: true
    }
  }

  toggleSort(col) {
    if (this.state.sortCol == col) {
      this.setState({
        ...this.state,
        sortAsc: !this.state.sortAsc
      })
    } else {
      this.setState({
        ...this.state,
        sortCol: col,
        sortAsc: true
      })
    }
  }

  showIcon(col) {
    if (this.state.sortCol === col) {
      if (this.state.sortAsc) {
        return <i className="fal fa-sort-asc" style={{ fontSize: '.7em' }}></i>
      }

      return <i className="fal fa-sort-desc" style={{ fontSize: '.7em' }}></i>
    }

    return <i className="fal fa-sort" style={{ fontSize: '.7em' }}></i>
  }

  sortIt(inp) {
    switch (this.state.sortCol) {
      case 0:
        const sorted = inp.sort((a, b) => {
          return (a.occupation.soc_code || '').localeCompare(b.occupation.soc_code, {
            sensitivity: 'base'
          })
        })

        return this.state.sortAsc ? sorted : sorted.reverse()
      case 1:
        const sorted2 = inp.sort((a, b) => {
          return (a.occupation.title || '').localeCompare(b.occupation.title, {
            sensitivity: 'base'
          })
        })

        return this.state.sortAsc ? sorted2 : sorted2.reverse()
      case 2:
        const sorted3 = inp.sort((a, b) => {
          return (a.occupation.pathway_name || '').localeCompare(
            b.occupation.pathway_name,
            { sensitivity: 'base' }
          )
        })

        return this.state.sortAsc ? sorted3 : sorted3.reverse()
      case 4:
        const sorted4 = inp.sort((a, b) => {
          if (a.demand.estimated_jobs - b.demand.estimated_jobs > 0) {
            return -1
          }

          if (b.demand.estimated_jobs - a.demand.estimated_jobs > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted4 : sorted4.reverse()
      case 5:
        const sorted5 = inp.sort((a, b) => {
          if (a.demand.projected_jobs - b.demand.projected_jobs > 0) {
            return -1
          }

          if (b.demand.projected_jobs - a.demand.projected_jobs > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted5 : sorted5.reverse()
      case 6:
        const sorted6 = inp.sort((a, b) => {
          if (a.demand.annual_total - b.demand.annual_total > 0) {
            return -1
          }

          if (b.demand.annual_total - a.demand.annual_total > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted6 : sorted6.reverse()
      case 7:
        const sorted7 = inp.sort((a, b) => {
          if (a.supply.distributed - b.supply.distributed > 0) {
            return -1
          }

          if (b.supply.distributed - a.supply.distributed > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted7 : sorted7.reverse()
      case 8:
        const sorted8 = inp.sort((a, b) => {
          const a1 = a.supply.distributed || 0
          const b1 = b.demand.annual_total || 0

          if (a1 - b1 > 0) {
            return -1
          }

          if (b1 - a1 > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted8 : sorted8.reverse()
      case 9:
        const sorted9 = inp.sort((a, b) => {
          if (a.supply.undistributed - b.supply.undistributed > 0) {
            return -1
          }

          if (b.supply.undistributed - a.supply.undistributed > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted9 : sorted9.reverse()
      default:
        return inp
    }

    return inp
  }

  render() {
    const d = this.sortIt(
      this.props.data.filter(f => f.occupation.cluster_id === this.props.clusterId)
    )
    const baseEmploymentYear = 2014
    const projectionYear = baseEmploymentYear + 10
    const ipedsYear = 2020

    return (
      <div>
        <table className="tbl table tbl-striped">
          <thead>
            <tr>
              <th>
                <a
                  href="javascript:void(0)"
                  style={{ whiteSpace: 'nowrap' }}
                  onClick={() => this.toggleSort(0)}>
                  {t`SOC Code`} {this.showIcon(0)}
                </a>
              </th>
              <th>
                <a
                  href="javascript:void(0)"
                  style={{ whiteSpace: 'nowrap' }}
                  onClick={() => this.toggleSort(1)}>
                  {t`Title`} {this.showIcon(1)}
                </a>
              </th>
              <th>
                <a
                  href="javascript:void(0)"
                  style={{ whiteSpace: 'nowrap' }}
                  onClick={() => this.toggleSort(2)}>
                  {t`Pathway`} {this.showIcon(2)}
                </a>
              </th>
              <th>{t`In Demand`}</th>
              <th>
                <a href="javascript:void(0)" onClick={() => this.toggleSort(4)}>
                  {t`${baseEmploymentYear} Employment`} {this.showIcon(4)}
                </a>
              </th>
              <th>
                <a href="javascript:void(0)" onClick={() => this.toggleSort(5)}>
                  {t`${projectionYear} Projections`} {this.showIcon(5)}
                </a>
              </th>
              <th>
                <a href="javascript:void(0)" onClick={() => this.toggleSort(6)}>
                  {t`Annual Demand`} {this.showIcon(6)}
                </a>
              </th>
              <th>
                <a href="javascript:void(0)" onClick={() => this.toggleSort(7)}>
                  {t`${ipedsYear} Supply (distributed)`} {this.showIcon(7)}
                </a>
              </th>
              <th>
                <a href="javascript:void(0)" onClick={() => this.toggleSort(8)}>
                  {t`Gap`} {this.showIcon(8)}
                </a>
              </th>
              <th>
                <a href="javascript:void(0)" onClick={() => this.toggleSort(9)}>
                  {t`${ipedsYear} Supply (total)`} {this.showIcon(9)}
                </a>
              </th>
            </tr>
          </thead>
          <tbody>
            {d.map((o, idx) => {
              const dmd = o.demand
              const sup = o.supply
              const d = o.occupation

              return (
                <tr key={d.soc_code} className={idx % 2 ? 'even' : 'odd'}>
                  <td>{d.soc_code}</td>
                  <td>{d.title}</td>
                  <td>{d.pathway_name}</td>
                  <td>
                    {this.props.inDemand.find(i => i.substring(0, 7) === d.soc_code) !=
                    null ? (
                      <i className="check">
                        <span className="sr-only">x</span>
                      </i>
                    ) : (
                      <span></span>
                    )}
                  </td>
                  <td>{dmd.estimated_jobs && dmd.estimated_jobs.toLocaleString()}</td>
                  <td>{dmd.projected_jobs && dmd.projected_jobs.toLocaleString()}</td>
                  <td>{dmd.annual_total && dmd.annual_total.toLocaleString()}</td>
                  <td>{sup.distributed && sup.distributed.toLocaleString()}</td>
                  <td>
                    {((sup.distributed || 0) - (dmd.annual_total || 0)).toLocaleString()}
                  </td>
                  <td>{sup.undistributed && sup.undistributed.toLocaleString()}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }
}

class OccSupplyDemand extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      sortCol: null,
      sortAsc: true
    }
  }

  toggleSort(col) {
    if (this.state.sortCol == col) {
      this.setState({
        ...this.state,
        sortAsc: !this.state.sortAsc
      })
    } else {
      this.setState({
        ...this.state,
        sortCol: col,
        sortAsc: true
      })
    }
  }

  showIcon(col) {
    if (this.state.sortCol === col) {
      if (this.state.sortAsc) {
        return <i className="fal fa-sort-asc" style={{ fontSize: '.7em' }}></i>
      }

      return <i className="fal fa-sort-desc" style={{ fontSize: '.7em' }}></i>
    }

    return <i className="fal fa-sort" style={{ fontSize: '.7em' }}></i>
  }

  sortIt(inp) {
    switch (this.state.sortCol) {
      case 0:
        const sorted = inp.sort((a, b) => {
          return (a.occupation.soc_code || '').localeCompare(b.occupation.soc_code, {
            sensitivity: 'base'
          })
        })

        return this.state.sortAsc ? sorted : sorted.reverse()
      case 1:
        const sorted2 = inp.sort((a, b) => {
          return (a.occupation.title || '').localeCompare(b.occupation.title, {
            sensitivity: 'base'
          })
        })

        return this.state.sortAsc ? sorted2 : sorted2.reverse()
      case 2:
        const sorted3 = inp.sort((a, b) => {
          return (a.occupation.name || '').localeCompare(b.occupation.name, {
            sensitivity: 'base'
          })
        })

        return this.state.sortAsc ? sorted3 : sorted3.reverse()
      case 4:
        const sorted4 = inp.sort((a, b) => {
          if (a.demand.estimated_jobs - b.demand.estimated_jobs > 0) {
            return -1
          }

          if (b.demand.estimated_jobs - a.demand.estimated_jobs > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted4 : sorted4.reverse()
      case 5:
        const sorted5 = inp.sort((a, b) => {
          if (a.demand.projected_jobs - b.demand.projected_jobs > 0) {
            return -1
          }

          if (b.demand.projected_jobs - a.demand.projected_jobs > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted5 : sorted5.reverse()
      case 6:
        const sorted6 = inp.sort((a, b) => {
          if (a.demand.annual_total - b.demand.annual_total > 0) {
            return -1
          }

          if (b.demand.annual_total - a.demand.annual_total > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted6 : sorted6.reverse()
      case 7:
        const sorted7 = inp.sort((a, b) => {
          if (a.supply.distributed - b.supply.distributed > 0) {
            return -1
          }

          if (b.supply.distributed - a.supply.distributed > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted7 : sorted7.reverse()
      case 8:
        const sorted8 = inp.sort((a, b) => {
          const a1 = a.supply.distributed || 0
          const b1 = b.demand.annual_total || 0

          if (a1 - b1 > 0) {
            return -1
          }

          if (b1 - a1 > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted8 : sorted8.reverse()
      case 9:
        const sorted9 = inp.sort((a, b) => {
          if (a.supply.undistributed - b.supply.undistributed > 0) {
            return -1
          }

          if (b.supply.undistributed - a.supply.undistributed > 0) {
            return 1
          }

          return 0
        })

        return this.state.sortAsc ? sorted9 : sorted9.reverse()
      default:
        return inp
    }

    return inp
  }

  render() {
    const d = this.sortIt(this.props.data)
    const baseEmploymentYear = 2014
    const projectionYear = baseEmploymentYear + 10
    const ipedsYear = 2020

    return (
      <div>
        <table className="tbl table tbl-striped">
          <thead>
            <tr>
              <th>
                <a
                  href="javascript:void(0)"
                  style={{ whiteSpace: 'nowrap' }}
                  onClick={() => this.toggleSort(0)}>
                  {t`SOC Code`} {this.showIcon(0)}
                </a>
              </th>
              <th>
                <a
                  href="javascript:void(0)"
                  style={{ whiteSpace: 'nowrap' }}
                  onClick={() => this.toggleSort(1)}>
                  {t`Title`} {this.showIcon(1)}
                </a>
              </th>
              <th>
                <a
                  href="javascript:void(0)"
                  style={{ whiteSpace: 'nowrap' }}
                  onClick={() => this.toggleSort(2)}>
                  {t`Cluster`} {this.showIcon(2)}
                </a>
              </th>
              <th>{t`In Demand`}</th>
              <th>
                <a href="javascript:void(0)" onClick={() => this.toggleSort(4)}>
                  {t`${baseEmploymentYear} Employment`} {this.showIcon(4)}
                </a>
              </th>
              <th>
                <a href="javascript:void(0)" onClick={() => this.toggleSort(5)}>
                  {t`${projectionYear} Projections`} {this.showIcon(5)}
                </a>
              </th>
              <th>
                <a href="javascript:void(0)" onClick={() => this.toggleSort(6)}>
                  {t`Annual Demand`} {this.showIcon(6)}
                </a>
              </th>
              <th>
                <a href="javascript:void(0)" onClick={() => this.toggleSort(7)}>
                  {t`${ipedsYear} Supply (distributed)`} {this.showIcon(7)}
                </a>
              </th>
              <th>
                <a href="javascript:void(0)" onClick={() => this.toggleSort(8)}>
                  {t`Gap`} {this.showIcon(8)}
                </a>
              </th>
              <th>
                <a href="javascript:void(0)" onClick={() => this.toggleSort(9)}>
                  {t`${ipedsYear} Supply (total)`} {this.showIcon(9)}
                </a>
              </th>
            </tr>
          </thead>
          <tbody>
            {d.map((o, idx) => {
              const dmd = o.demand
              const sup = o.supply
              const d = o.occupation

              return (
                <tr key={d.soc_code} className={idx % 2 ? 'even' : 'odd'}>
                  <td>{d.soc_code}</td>
                  <td>{d.title}</td>
                  <td>
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        this.setState({
                          ...this.state,
                          clusterId: d.cluster_id,
                          clusterName: d.name
                        })
                      }}>
                      {d.name}
                    </a>
                  </td>
                  <td>
                    {this.props.inDemand.find(i => i.substring(0, 7) === d.soc_code) !=
                    null ? (
                      <i className="check">
                        <span className="sr-only">x</span>
                      </i>
                    ) : (
                      <span></span>
                    )}
                  </td>
                  <td>{dmd.estimated_jobs && dmd.estimated_jobs.toLocaleString()}</td>
                  <td>{dmd.projected_jobs && dmd.projected_jobs.toLocaleString()}</td>
                  <td>{dmd.annual_total && dmd.annual_total.toLocaleString()}</td>
                  <td>{sup.distributed && sup.distributed.toLocaleString()}</td>
                  <td>
                    {((sup.distributed || 0) - (dmd.annual_total || 0)).toLocaleString()}
                  </td>
                  <td>{sup.undistributed && sup.undistributed.toLocaleString()}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <Modal
          show={!!this.state.clusterId}
          onHide={() =>
            this.setState({ ...this.state, clusterId: null, clusterName: null })}
          dialogClassName="fullscreen-modal">
          <Modal.Header
            style={{
              color: 'white',
              fontWeight: 'bold'
            }}>
            <button
              type="button"
              className="close"
              onClick={() =>
                this.setState({ ...this.state, clusterId: null, clusterName: null })}
              aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h2>Pathways in {this.state.clusterName}</h2>
          </Modal.Header>
          <Modal.Body>
            <OccSupplyDemandPathway clusterId={this.state.clusterId} {...this.props} />
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

const SupplyDemand = state => {
  useInitDispatch(loadSupplyDemand())
  useTitleChange(t`Supply / Demand`)

  const {
    crosswalk,
    supply,
    demand,
    occupationsInCluster,
    loading,
    inDemand,
    clusters,
    jobZones
  } = state

  if (loading) {
    return <LoadingIndicator newSiteLook={dynamicValues.newSiteLook} />
  }

  const {
    Bar,
    BarChart,
    ReferenceLine,
    ResponsiveContainer,
    XAxis,
    YAxis
  } = state.recharts
  const sTable = supply
  const dTable = demand
  const findSupply = (soc, dmd) => {
    const distribute = cip => {
      const d = crosswalk
        .filter(c => c.instructional_program === cip.cip_code)
        .map(c => {
          const s = dTable.find(s => s.soc_code === c.soc_code)

          //console.log(s)
          if (s) {
            return {
              soc_code: s.soc_code,
              demand: s.annual_total
            }
          }

          return { demand: 0 }
        })
        .reduce((a, b) => a + b.demand, 0)
      //                console.log(d, dmd)
      const proportion = dmd && d ? (d == 0 ? 0 : dmd.annual_total / d) : 1

      return cip.supply * proportion
    }
    const cips = crosswalk
      .filter(c => c.soc_code === soc)
      .map(c => {
        return {
          cip_code: c.instructional_program,
          supply: (sTable.find(s => s.cipcode === c.instructional_program) || { sum: 0 })
            .sum
        }
      })

    return {
      distributed: Math.round(cips.reduce((a, b) => a + distribute(b), 0)),
      undistributed: cips.reduce((a, b) => a + b.supply, 0)
    }
  }
  const findDemand = soc => {
    const d = dTable.find(d => d.soc_code === soc)

    return d ? d : null
  }
  const jzData = () => {
    const myData = {}

    occupationsInCluster.forEach(d => {
      const dmd = findDemand(d.soc_code)
      const sup = findSupply(d.soc_code, dmd)

      if (sup && dmd) {
        const c = myData[d.jobZone] || { v: 0, sup: 0, dmd: 0 }

        myData[d.jobZone] = {
          name: d.name,
          jobZone: d.jobZone,
          sup: c.sup + (sup.distributed || 0),
          dmd: c.dmd + (dmd.annual_total || 0),
          v: c.v + ((sup.distributed || 0) - (dmd.annual_total || 0))
        }
      }
    })

    return Object.values(myData)
  }
  const clusterData = () => {
    const myData = {}

    occupationsInCluster.forEach(d => {
      const dmd = findDemand(d.soc_code)
      const sup = findSupply(d.soc_code, dmd)

      if (sup && dmd) {
        const c = myData[d.name] || { v: 0, sup: 0, dmd: 0 }

        myData[d.name] = {
          name: d.name,
          clusterId: d.cluster_id,
          sup: c.sup + (sup.distributed || 0),
          dmd: c.dmd + (dmd.annual_total || 0),
          v: c.v + ((sup.distributed || 0) - (dmd.annual_total || 0))
        }
      }
    })

    return Object.values(myData)
  }
  const chart = () => {
    const data = () => {
      return occupationsInCluster.map(d => {
        const dmd = findDemand(d.soc_code)
        const sup = findSupply(d.soc_code, dmd)

        if (sup && dmd) {
          return {
            name: d.soc_code,
            v: (sup.distributed || 0) - (dmd.annual_total || 0)
          }
        }

        return null
      })
    }
    const d = clusterData().sort((a, b) => {
      return a.v - b.v
    })

    console.log(d)

    return (
      <ResponsiveContainer aspect={1} width="100%">
        <BarChart
          width={100}
          height={100}
          data={d}
          margin={{ top: 5, right: 10, left: 200, bottom: 5 }}
          layout="vertical">
          <XAxis type="number" />
          <YAxis type="category" dataKey="name" />
          <ReferenceLine y={0} stroke="#000" />
          <Bar dataKey="v" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    )
  }

  //demand.forEach(i => console.log(i.substring(0, 7) ))

  const occSupDmdD = occupationsInCluster
    .map(d => {
      const dmd = findDemand(d.soc_code)

      return {
        occupation: d,
        demand: dmd,
        supply: findSupply(d.soc_code, dmd)
      }
    })
    .filter(d => d.demand != null)

  return (
    <div className="container" id="profileinfocontainer">
      <div className="filter">
        <div className="col-xs-4">
          <label>{t`Cluster`}</label>
          <select className="form-control">
            <option value="-1">{t`All Clusters`}</option>
            {clusters.map(c => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-xs-4">
          <label>{t`Job Zone`}</label>
          <select className="form-control">
            <option value="-1">{t`All Job Zones`}</option>
            {jobZones.map(c => (
              <option>{c.name}</option>
            ))}
          </select>
        </div>
        <br className="clear" />
        <div className="clear actions text-center">
          <button className="btn btn-small btn-gray">{t`Filter`}</button>
        </div>
      </div>
      {chart()}
      <br />
      <div className="section">
        <h3>
          <span>{t`Cluster Supply/Demand`}</span>
        </h3>
        <SupplyDemandCluster data={clusterData()} />

        <br className="clear" />
        <h3>
          <span>{t`JobZone Supply/Demand`}</span>
        </h3>
        <SupplyDemandJZ data={jzData()} />
        <br className="clear" />
        <h3>
          <span>{t`Occupational Supply/Demand`}</span>
        </h3>
        <OccSupplyDemand inDemand={inDemand} data={occSupDmdD} />
      </div>
    </div>
  )
}

export default connect(
  state => {
    return {
      ...state.industry.supply
    }
  },
  dispatch => ({})
)(withRecharts(SupplyDemand))
